import { selectMovimentiList } from 'features/ippica/selectors';
import { useTypedSelector } from 'lib/centralStore';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import { RootState } from 'sites/snai/lib/store';
import { IppicaQuoteFinaliBox } from '../ippicaQuote/ippicaQuoteFinaliBox';
import styles from './IppicaMovimenti.module.scss';
export const DynamicIppicaMovimenti = dynamic(() =>
  import('features/ippica/components/ippicaMovimenti').then((mod) => mod.IppicaMovimenti)
);

export const IppicaMovimenti = () => {
  const { isOpen } = useSelector((store: RootState) => store.carrello);
  const movimentiList = useTypedSelector(selectMovimentiList);
  return (
    <>
      {!!movimentiList?.length ? (
        <section
          className={`${styles.movimentiContainer} ${!isOpen ? styles.withMarginRight : ''} ${styles.withMarginBottom}`}
        >
          <h3 className={styles.title}>Movimenti</h3>
          <IppicaQuoteFinaliBox esitoList={movimentiList} />
        </section>
      ) : null}
    </>
  );
};
